import moment from 'moment'
const timetable = {
  namespaced: true,
  state: {
    routes: {
      list: null,
      stops: [],
      destinations: [],
      departures: [],
      passingTimes: [],
    },
    lines: {
      list: null,
    },
    pysakit: {
      list: null,
    },
    organisations: {
      list: [],
      data: [],
    },
    availableOrganisations: {
      list: [],
    },
    daytypes: {
      list: [],
    },
    seasons: {
      list: [],
      routes: [],
    },
    route: null,
    organisationStopFeatures: {
      list: [],
    },
    organisationLineFeatures: {
      list: [],
    },
    predictionHistory: {
      list: [],
    },
  },
  mutations: {
    setRoutesList(state, newList) {
      state.routes.list = newList
    },
    setLinesList(state, newList) {
      state.lines.list = newList
    },
    setPysakitList(state, newList) {
      state.pysakit.list = newList
    },
    setOrganisationList(state, newList) {
      state.organisations.list = newList
    },
    setOrganisationListData(state, newList) {
      state.organisations.data = newList
    },
    setAvailableOrganisations(state, newList) {
      state.availableOrganisations.list = newList
    },
    setRouteDestinations(state, newList) {
      state.routes.destinations = newList
    },
    setRouteStops(state, newList) {
      state.routes.stops = newList
    },
    setRouteDepartures(state, newList) {
      state.routes.departures = newList
    },
    setPassingTimes(state, newList) {
      state.routes.passingTimes = newList
    },
    setRouteData(state, newItem) {
      state.route = newItem
    },
    setDayTypeList(state, newList) {
      state.daytypes.list = newList
    },
    setSeasonList(state, newList) {
      state.seasons.list = newList
    },
    setSeasonRoutes(state, newList) {
      state.seasons.routes = newList
    },
    setOrganisationStopFeatures(state, newList) {
      state.organisationStopFeatures.list = newList
    },
    setOrganisationLineFeatures(state, newList) {
      state.organisationLineFeatures.list = newList
    },
    setPredictionHistoryList(state, newList) {
      state.predictionHistory.list = newList
    },
  },
  actions: {
    getRoutesListData(context) {
      return new Promise((resolve, reject) => {
        const vm = this
        this._vm.$traveller_http
          .get('/traveller/restui/timetables/route/getRoutes')
          .then(function (resp) {
            if (resp.data.code !== undefined) {
              reject('error in query')
              return
            }
            vm.listData = resp.data
            context.commit('setRoutesList', resp.data)
            resolve(resp.data)
          })
      })
    },
    deleteRoute(context, route) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post('/traveller/restui/timetables/route/deleteRoute', route)
          .then((response) => {
            if (response.status == 200)
              context.dispatch('getRoutesWithDestinations')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateRoute(context, newRoute) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post('/traveller/restui/timetables/route/saveRoute', newRoute)
          .then((response) => {
            if (response.status == 200)
              context.dispatch('getRoutesWithDestinations')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getRouteDestinations(context, route) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/timetables/route/getRouteDestinations', {
            params: { route: route },
          })
          .then((response) => {
            context.commit('setRouteDestinations', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getRouteStops(context, route) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/timetables/route/getRouteStops', {
            params: { route: route },
          })
          .then((response) => {
            context.commit('setRouteStops', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getRouteDepartures(context, route) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/timetables/route/getRouteDepartures', {
            params: { route: route },
          })
          .then((response) => {
            context.commit('setRouteDepartures', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getSeasonRoutes(context, season) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/timetables/route/getSeasonRoutes', {
            params: { season: season },
          })
          .then((response) => {
            context.commit('setSeasonRoutes', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getPassingTimes(context, departureJson) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/timetables/route/getPassingTimes', {
            params: { departure: departureJson },
          })
          .then((response) => {
            context.commit('setPassingTimes', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getRoutesWithDestinations(context) {
      return new Promise((resolve, reject) => {
        const vm = this
        this._vm.$traveller_http
          .get('/traveller/restui/timetables/route/getRoutesWithDestinations')
          .then(function (resp) {
            if (resp.data.code !== undefined) {
              reject('error in query')
              return
            }
            vm.listData = resp.data
            context.commit('setRoutesList', resp.data)
            resolve(resp.data)
          })
      })
    },

    getLinesListData(context) {
      return new Promise((resolve, reject) => {
        const vm = this
        this._vm.$traveller_http
          .get('/traveller/restui/timetables/line/getLines')
          .then(function (resp) {
            if (resp.data.code !== undefined) {
              reject('error in query')
              return
            }
            vm.listData = resp.data
            context.commit('setLinesList', resp.data)
            resolve(resp.data)
          })
      })
    },
    deleteLine(context, lineId) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          },
        }
        this._vm.$traveller_http
          .post('/traveller/restui/timetables/line/deleteLine', lineId, config)
          .then((response) => {
            if (response.status == 200) context.dispatch('getLinesListData')
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    updateLine(context, newLine) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post('/traveller/restui/timetables/line/saveLine', newLine)
          .then((response) => {
            if (response.status == 200) context.dispatch('getLinesListData')
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    deleteDestination(context, destination, route) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post(
            '/traveller/restui/timetables/route/deleteDestination',
            destination
          )
          .then((response) => {
            if (response.status == 200) context.commit('setRouteData', route)
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    deleteDestinations(context, destinations, route) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post(
            '/traveller/restui/timetables/route/deleteDestinations',
            destinations
          )
          .then((response) => {
            if (response.status == 200) context.commit('setRouteData', route)
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    updateDestination(context, destination, route) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post(
            '/traveller/restui/timetables/route/saveDestination',
            destination
          )
          .then((response) => {
            if (response.status == 200) context.commit('setRouteData', route)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleteRoutestop(context, routestop, route) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post('/traveller/restui/timetables/route/deleteRoutestop', routestop)
          .then((response) => {
            if (response.status == 200) context.commit('setRouteData', route)
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    deleteDeparture(context, departure, route) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post('/traveller/restui/timetables/route/deleteDeparture', departure)
          .then((response) => {
            if (response.status == 200) context.commit('setRouteData', route)
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    updateRoutestop(context, routestop, route) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post('/traveller/restui/timetables/route/saveRoutestop', routestop)
          .then((response) => {
            if (response.status == 200) context.commit('setRouteData', route)
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    updateRoutestops(context, routestops, route) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post('/traveller/restui/timetables/route/saveRoutestops', routestops)
          .then((response) => {
            if (response.status == 200) context.commit('setRouteData', route)
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    updateSeason(context, newSeason) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post('/traveller/restui/timetables/route/saveSeason', newSeason)
          .then((response) => {
            if (response.status == 200) context.dispatch('getSeasonList')
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    deleteSeason(context, seasonId) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          },
        }
        this._vm.$traveller_http
          .post(
            '/traveller/restui/timetables/route/deleteSeason',
            seasonId,
            config
          )
          .then((response) => {
            if (response.status == 200) context.dispatch('getSeasonList')
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    updateSeasonRoute(context, seasonroute, season) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post(
            '/traveller/restui/timetables/route/saveSeasonRoute',
            seasonroute
          )
          .then((response) => {
            if (response.status == 200)
              context.commit('setSeasonRoutes', season)
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    getOrganisationList(context) {
      this._vm.$traveller_http
        .get('/traveller/restui/organizations/list')
        .then((response) => {
          context.commit('setOrganisationList', response.data)
        })
    },
    getOrganisations(context) {
      this._vm.$traveller_http
        .get('/traveller/restui/organizations')
        .then((response) => {
          context.commit('setOrganisationListData', response.data)
        })
    },
    getAvailableOrganisations(context, organisation) {
      this._vm.$traveller_http
        .get('/traveller/restui/available-organizations', {
          params: { organisation: organisation },
        })
        .then((response) => {
          context.commit('setAvailableOrganisations', response.data)
        })
    },
    updateOrganisation(context, newOrganisation) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post('/traveller/restui/organizations', newOrganisation)
          .then((response) => {
            if (response.status == 200) context.dispatch('getOrganisationList')
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    deleteOrganisation(context, orgId) {
      return new Promise((resolve, reject) => {
        //   var config = {
        //       headers: {
        //           'Content-Type': 'application/json;charset=UTF-8'
        //       }
        //   }
        this._vm.$traveller_http
          .delete(`/traveller/restui/organizations/${orgId}`)
          .then((response) => {
            if (response.status == 200) context.dispatch('getOrganisationList')
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    getSeasonList(context) {
      this._vm.$traveller_http
        .get('/traveller/restui/timetables/route/getSeasons')
        .then((response) => {
          context.commit('setSeasonList', response.data)
        })
    },
    getDayTypeList(context) {
      this._vm.$traveller_http
        .get('/traveller/restui/timetables/route/getDayTypes')
        .then((response) => {
          context.commit('setDayTypeList', response.data)
        })
    },
    getOrganisationStopFeatures(context) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/timetables/stop/getOrganisationStopFeatures')
          .then((response) => {
            context.commit('setOrganisationStopFeatures', response.data)
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    getOrganisationLineFeatures(context, organization) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get(
            '/traveller/restui/timetables/line/getOrganizationLineFeatures',
            { params: { organization: organization } }
          )
          .then((response) => {
            context.commit('setOrganisationLineFeatures', response.data)
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    saveDepartures(context, departures, route) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post('/traveller/restui/timetables/route/saveDepartures', departures)
          .then((response) => {
            if (response.status == 200) context.commit('setRouteData', route)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    savePassingTimes(context, departures, route) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post(
            '/traveller/restui/timetables/route/savePassingTimes',
            departures
          )
          .then((response) => {
            if (response.status == 200) context.commit('setRouteData', route)
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    getPysakkiListData(context) {
      return new Promise((resolve, reject) => {
        const vm = this
        this._vm.$traveller_http
          .get('/traveller/restui/timetables/stop/getPysakit')
          .then(function (resp) {
            if (resp.data.code !== undefined) {
              reject('error in query')
              return
            }
            vm.listData = resp.data
            context.commit('setPysakitList', resp.data)
            resolve(resp.data)
          })
      })
    },
    getPredictionHistory(context, paramsIn) {
      return new Promise((resolve, reject) => {
        if (paramsIn) {
          var passTime = new moment(paramsIn.passingTime)
          paramsIn.passingTime = passTime.format()

          this._vm.$traveller_http
            .get('/atraveller/rest/departureinfo/departureUpdates', {
              params: paramsIn,
            })
            .then((response) => {
              if (response.status == 200) {
                context.commit('setPredictionHistoryList', response.data)
                resolve(response)
              } else {
                reject()
              }
            })
            .catch((error) => {
              reject(error)
            })
        } else {
          reject('Missing parameters')
        }
      })
    },
  },
  getters: {},
}

export default timetable
